module.exports = __webpack_public_path__ + "fonts/RocGrotesk-Black.4649a68.woff";